import React, { useState } from 'react';
import { GetJobImages_getJobImages as JobImagesList } from '../../../types/schemaTypes';
import './MileageConfirmation.scss';
import DeleteModal from '../DeleteModal';
import FullLoadImage from '../../LoadProfile/LoadProgress/LoadImage/FullLoadImage';
import moment from 'moment';
import FullJobImage from './FullJobImage';
import { Col } from 'react-bootstrap';

interface JobImageItemProps {
    image: JobImagesList;
    index: number;
    canEditJobs: boolean;
    onDelete?: (record: any) => void;
}

const MileageConfirmationImageItem = ({ image, index, canEditJobs, onDelete }: JobImageItemProps): React.ReactElement => {
    const [showModal, setShowModal] = useState(false);
    const { downloadLink, uploadDate, imageName, uploadedBy } = image;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const datePart = moment(image.uploadDate?.toString()).format('MMM DD, YYYY');
    const timePart = moment(image.uploadDate?.toString()).format('h:mm A');
    const isOdd = index % 2 == 1;
    const containerStyle = `ImageList-Bottom-Container ${!isOdd && 'ImageList-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(image);
        setDeleteConfirm(false);
    };

    const handleOnClick = (): void => {
        setShowModal(!showModal);
    };

    return (
        <div className={containerStyle}>
            <Col md={4}>
                <div className="ImageItem-List-Header">
                    <i className="material-icons image">image</i>
                    <div className="ImageItem-List-Header-ImageLink" onClick={handleOnClick}>
                        {imageName}
                    </div>
                    {showModal && (
                        <FullJobImage
                            onClickShow={() => setShowModal(true)}
                            show={showModal}
                            onClickHide={handleOnClick}
                            image={downloadLink ? downloadLink : ''}
                            imageName={imageName ? imageName : ''}
                        />
                    )}
                </div>
            </Col>
            <div className="ImageItem-List-Header">{`${datePart} at ${timePart}`}</div>
            <div className="ImageItem-List-Header" style={{ position: 'relative', left: '15px' }}>
                {uploadedBy}
            </div>
            <div className="GridViewItem-ImageList-Header">
                {canEditJobs && onDelete && (
                    <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-DeleteImage-Container'}`}>
                        <i className="material-icons UsersItem-Icon">delete</i>
                        <span className="UsersItem-Link">Delete</span>
                    </div>
                )}
                <DeleteModal
                    show={deleteConfirm}
                    name={'image'}
                    onConfirm={handleDelete}
                    onCancel={() => setDeleteConfirm(false)}
                />
            </div>
        </div>
    );
};

export default MileageConfirmationImageItem;

